export default {
  login: {
    validation: {
      username: {
        required: 'Username is required',
      },
      password: {
        required: 'Password is required',
      },
    },
    notACustomer: 'Not a Webeo customer yet?',
    getInTouch: 'Get in touch to arrange a demo and learn more about working with Webeo',
    loginForm: 'Login',
    loginButton: 'Log In',
    learnMore: 'Learn More',
  },
  sideNav: {
    supportRequest: 'Support Request',
    feedback: 'Feedback',
  },
  tutorialPopup: {
    createCampaignTile: {
      text: `Campaigns are a framework for organising audiences you want to target, and 
what personalized experiences they see`,
    },
  },
};
